// extracted by mini-css-extract-plugin
export default {"content":"fJ9TWZ","mobile":"Y4_xAd","button":"gnLv_b","title":"yeFTiN"};